<div class="min-h-screen flex flex-col bg-gray-50 w-full mx-auto font-prompt relative">
  <!-- 1. Header บาร์ด้านบน -->
  <div
    class="w-full bg-(--header-background) px-4 py-3 flex items-center justify-between sticky top-0 z-30 shadow-sm text-white select-none">
    <button (click)="goBack()"
      class="flex items-center text-white hover:opacity-80 active:scale-95 transition-all outline-none">
      <img src="icons/arrow_back_white.svg" />
    </button>
    <h1 class="text-sm font-bold tracking-wide" style="margin-bottom: 0;">
      {{ currentLang === "TH" ? "ข่าวสาร & โปรโมชั่น" : "News & Promotions" }}
    </h1>
    <div class="w-6"></div> <!-- Spacer -->
  </div>

  <!-- 2. Segmented Tabs เลือกประเภทข่าวสาร/โปรโมชั่น -->
  <div class="mx-4 mt-4 bg-gray-200/60 p-1 rounded-2xl flex text-xs font-bold text-gray-500 select-none">
    <button (click)="changeTab('all')"
      class="flex-1 py-2.5 rounded-xl transition-all duration-300 text-center outline-none"
      [class.bg-white]="selectedTab === 'all'" [class.text-gray-800]="selectedTab === 'all'"
      [class.shadow-sm]="selectedTab === 'all'">
      {{ currentLang === "TH" ? "ทั้งหมด" : "All" }}
    </button>
    <button (click)="changeTab('promo')"
      class="flex-1 py-2.5 rounded-xl transition-all duration-300 text-center outline-none"
      [class.bg-white]="selectedTab === 'promo'" [class.text-gray-800]="selectedTab === 'promo'"
      [class.shadow-sm]="selectedTab === 'promo'">
      {{ currentLang === "TH" ? "โปรโมชั่น" : "Promotions" }}
    </button>
    <button (click)="changeTab('news')"
      class="flex-1 py-2.5 rounded-xl transition-all duration-300 text-center outline-none"
      [class.bg-white]="selectedTab === 'news'" [class.text-gray-800]="selectedTab === 'news'"
      [class.shadow-sm]="selectedTab === 'news'">
      {{ currentLang === "TH" ? "ข่าวสาร" : "News" }}
    </button>
  </div>

  <!-- 3. กล่องค้นหาข้อมูล (Live Search) -->
  <div class="mx-4 mt-3 relative select-none">
    <span class="absolute left-3.5 top-1/2 -translate-y-1/2"><img src="icons/search_slate.svg" /></span>
    <input type="text" [(ngModel)]="searchQuery"
      [placeholder]="currentLang === 'TH' ? 'ค้นหาโปรโมชั่น หรือข่าวสาร...' : 'Search promotion or news...'"
      class="w-full bg-white border border-gray-100 text-xs rounded-xl pl-9 pr-4 py-2.5 text-gray-800 outline-none shadow-sm focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
  </div>

  <!-- 4. รายการการ์ดข่าวสาร & โปรโมชั่น -->
  <div class="flex-grow px-4 pt-4 pb-20 space-y-4 overflow-y-auto scroll-smooth select-none">
    <!-- กรณีไม่มีข้อมูลข่าวสาร/โปรโมชั่น -->
    <div *ngIf="filteredPromotions.length === 0" class="flex flex-col items-center justify-center py-20 text-center">
      <div class="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center text-gray-400 mb-3 shadow-inner">
        <img src="icons/campaign_slate.svg" />
      </div>
      <p class="text-xs font-bold text-gray-400">{{ currentLang === "TH" ? "ไม่พบข้อมูลรายการ" : "No updates found" }}
      </p>
      <p class="text-[10px] text-gray-400 mt-1">{{ currentLang === "TH" ? "ลองค้นหาด้วยคำอื่น" : "Try searching for
        other keywords" }}</p>
    </div>

    <!-- การ์ดรายการโปรโมชั่น/ข่าวสารแต่ละตัว -->
    <div *ngFor="let item of filteredPromotions" (click)="openDetail(item)"
      class="bg-white rounded-3xl overflow-hidden border border-gray-100/70 shadow-sm hover:shadow-md active:scale-[0.99] transition-all cursor-pointer flex flex-col group text-left">
      <!-- แบนเนอร์ภาพข่าวสาร/โปรโมชั่น -->
      <div class="w-full h-40 overflow-hidden bg-gray-100 relative">
        <img [src]="item.image" alt="promotion"
          class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />

        <!-- ป้ายแท็กหมวดหมู่ข่าวสาร/โปรโมชั่น -->
        <span class="absolute top-3 left-3 text-[9px] font-bold px-2.5 py-1 rounded-full shadow-sm"
          [class.bg-amber-400]="item.tag === 'promo'" [class.text-white]="item.tag === 'promo'"
          [class.bg-slate-800]="item.tag === 'news'" [class.text-slate-100]="item.tag === 'news'">
          {{ currentLang === 'TH' ? item.tagTH : item.tagEN }}
        </span>
      </div>

      <!-- รายละเอียดบทความสั้น -->
      <div class="p-4 space-y-2">
        <div class="flex items-center justify-between">
          <span class="text-[9px] font-bold text-gray-400 flex items-center gap-1">
            <img src="icons/schedule_slate.svg" />
            {{ item.date }}
          </span>
        </div>

        <h3 class="text-xs font-bold text-gray-800 leading-snug group-hover:text-amber-500 transition-colors">
          {{ currentLang === 'TH' ? item.titleTH : item.titleEN }}
        </h3>

        <p class="text-[10px] text-gray-500 font-medium leading-relaxed line-clamp-2">
          {{ currentLang === 'TH' ? item.discountTH : item.discountEN }}
        </p>

        <div
          class="pt-2 border-t border-gray-50 flex items-center justify-between text-amber-500 font-bold text-[10px]">
          <span>{{ currentLang === 'TH' ? 'ดูรายละเอียดเพิ่มเติม' : 'Read details' }}</span>
          <img class="group-hover:translate-x-1 transition-transform" src="icons/arrow_forward_orange.svg" />
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 5. MODAL DETAIL POPUP (Centered popup modal) -->
<div *ngIf="selectedPromo"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fade-in p-4">
  <!-- แผ่นการ์ดเนื้อหาแบบเต็ม -->
  <div
    class="bg-white rounded-[2rem] w-full max-w-sm max-h-[85vh] overflow-y-auto shadow-2xl flex flex-col text-left animate-scale-up relative">

    <!-- ปุ่มปิด Modal -->
    <button (click)="closeDetail()"
      class="absolute top-4 right-4 w-7 h-7 rounded-full bg-white/90 hover:bg-gray-100 text-gray-600 flex items-center justify-center transition-all active:scale-90 outline-none z-10 shadow-md">
      <img src="icons/close_slate_dark.svg" />
    </button>

    <!-- ภาพส่วนหัวแบบเต็มบาน -->
    <div class="w-full h-44 overflow-hidden bg-gray-100 relative">
      <img [src]="selectedPromo.image" alt="promo" class="w-full h-full object-cover" />
      <span class="absolute bottom-3 left-4 text-[9px] font-bold px-2.5 py-1 rounded-full shadow-md"
        [class.bg-amber-400]="selectedPromo.tag === 'promo'" [class.text-white]="selectedPromo.tag === 'promo'"
        [class.bg-slate-800]="selectedPromo.tag === 'news'" [class.text-slate-100]="selectedPromo.tag === 'news'">
        {{ currentLang === 'TH' ? selectedPromo.tagTH : selectedPromo.tagEN }}
      </span>
    </div>

    <!-- เนื้อหาบทความด้านใน -->
    <div class="p-6 space-y-4 overflow-y-auto scroll-smooth flex-grow custom-scrollbar">
      <div class="space-y-1">
        <span class="text-[9px] font-bold text-gray-400 flex items-center gap-1 mb-1">
          <img src="icons/schedule_slate.svg" />
          {{ selectedPromo.date }}
        </span>
        <h2 class="text-sm font-bold text-gray-800 leading-snug">
          {{ currentLang === 'TH' ? selectedPromo.titleTH : selectedPromo.titleEN }}
        </h2>
        <p class="text-xs font-bold text-amber-500">
          {{ currentLang === 'TH' ? selectedPromo.discountTH : selectedPromo.discountEN }}
        </p>
      </div>

      <!-- เนื้อหาหลัก -->
      <div class="space-y-2">
        <h4 class="text-[10px] font-bold text-gray-700 uppercase tracking-wide">
          {{ currentLang === 'TH' ? 'รายละเอียด' : 'Description' }}
        </h4>
        <p class="text-[10px] text-gray-500 font-medium leading-relaxed whitespace-pre-line">
          {{ currentLang === 'TH' ? selectedPromo.detailTH : selectedPromo.detailEN }}
        </p>
      </div>

      <!-- เงื่อนไข / ข้อตกลง -->
      <div class="pt-3 border-t border-gray-100 space-y-2">
        <h4 class="text-[10px] font-bold text-gray-700 uppercase tracking-wide">
          {{ currentLang === 'TH' ? 'เงื่อนไขและข้อกำหนด' : 'Terms & Conditions' }}
        </h4>
        <p class="text-[10px] text-gray-400 font-medium leading-relaxed whitespace-pre-line">
          {{ currentLang === 'TH' ? selectedPromo.termsTH : selectedPromo.termsEN }}
        </p>
      </div>
    </div>

    <!-- ปุ่มตกลง / ปิดหน้ารายละเอียด -->
    <div class="p-6 bg-white border-t border-gray-50">
      <button (click)="closeDetail()"
        class="w-full bg-(--main-color) hover:from-amber-600 hover:to-yellow-500 text-white text-xs font-bold rounded-xl py-3 shadow-md transition-all duration-200 active:scale-95 outline-none">
        {{ currentLang === "TH" ? "รับทราบ" : "Close" }}
      </button>
    </div>
  </div>
</div>